import { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useCart } from '../../contexts/CartContext'
import { useLanguage } from '../../contexts/LanguageContext'
import styles from './Navbar.module.css'

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false)
  const { getTotalItems } = useCart()
  const { language, setLanguage, t } = useLanguage()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault()
    
    // Eğer sepetteyse, önce anasayfaya git
    if (location.pathname !== '/') {
      navigate('/')
      // Anasayfaya gittikten sonra scroll yapmak için kısa bir gecikme
      setTimeout(() => {
        const element = document.getElementById(sectionId)
        if (element) {
          const targetPosition = element.offsetTop - 80
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          })
        }
      }, 100)
    } else {
      // Zaten anasayfadaysa direkt scroll yap
      const element = document.getElementById(sectionId)
      if (element) {
        const targetPosition = element.offsetTop - 80
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        })
      }
    }
  }

  return (
    <nav className={`${styles.navbar} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.navContainer}>
        <Link to="/" className={styles.logo}>
          <img src="/logo.png" alt="3K Digitale" className={styles.logoImg} />
        </Link>
        <ul className={styles.navMenu}>
          <li>
            <a href="#home" onClick={(e) => scrollToSection(e, 'home')}>
              {t('nav.home')}
            </a>
          </li>
          <li>
            <a href="#packages-preview" onClick={(e) => scrollToSection(e, 'packages-preview')}>
              {t('nav.packages')}
            </a>
          </li>
          <li>
            <a href="#portfolio" onClick={(e) => scrollToSection(e, 'portfolio')}>
              {t('nav.portfolio')}
            </a>
          </li>
        </ul>
        <div className={styles.navActions}>
          <div className={styles.languageSelector}>
            <button
              className={`${styles.langButton} ${language === 'tr' ? styles.active : ''}`}
              onClick={() => setLanguage('tr')}
              title="Türkçe"
            >
              TR
            </button>
            <button
              className={`${styles.langButton} ${language === 'en' ? styles.active : ''}`}
              onClick={() => setLanguage('en')}
              title="English"
            >
              EN
            </button>
          </div>
          <div className={styles.cartSelector}>
            <Link to="/sepet" className={styles.cartButton}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
              {getTotalItems() > 0 && (
                <span className={styles.cartBadge}>{getTotalItems()}</span>
              )}
            </Link>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
